import jsPDF from "jspdf";

export const renderMarkdownToPDFFile = (textContent) => {
  const generatePdf = () => {
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const marginLeft = 15;
    const marginRight = 15;
    const usableWidth = doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const lineHeight = 8;
    let y = 20;

    const paragraphs = textContent.split(/\n\s*\n/);

    paragraphs.forEach((para) => {
      const lines = para.split(/\r?\n/);

      lines.forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) {
          y += lineHeight;
          return;
        }

        // Headings
        if (/^#{1,6}\s/.test(trimmed)) {
          const level = trimmed.match(/^#{1,6}/)[0].length;
          const headingText = trimmed.replace(/^#{1,6}\s*/, "");

          const fontSize = level === 1 ? 18 : level === 2 ? 14 : 12;
          doc.setFont("helvetica", "bold");
          doc.setFontSize(fontSize);

          const wrapped = doc.splitTextToSize(headingText, usableWidth);
          wrapped.forEach((txt) => {
            doc.text(txt, marginLeft, y);
            y += lineHeight;
          });

          doc.setFontSize(12);
          y += 2;
        }

        // Bullets
        else if (/^[-•*]\s+/.test(trimmed)) {
          const text = trimmed.replace(/^[-•*]\s+/, "");
          const wrapped = doc.splitTextToSize(text, usableWidth - 6);
          doc.text("•", marginLeft, y);
          wrapped.forEach((txt) => {
            doc.setFont("helvetica", "normal");
            renderInlineFormatting(doc, txt, marginLeft + 6, y);
            y += lineHeight;
          });
        }

        // Normal or inline bold text
        else {
          const wrapped = doc.splitTextToSize(trimmed, usableWidth);
          wrapped.forEach((txt) => {
            doc.setFont("helvetica", "normal");
            renderInlineFormatting(doc, txt, marginLeft, y);
            y += lineHeight;
          });
        }

        if (y > 280) {
          doc.addPage();
          y = 20;
        }
      });

      y += 4; // space between paragraphs
    });

    // Footer date-time
    const now = new Date();
    const formatted = now.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
    doc.setFont("helvetica", "italic");
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Generated on: ${formatted}`, 15, 290);

    // Base64 (for S3 upload)
    const pdfBase64 = doc.output("datauristring").split(",")[1];
    return pdfBase64;
  };

  // Render inline **bold** inside text
  const renderInlineFormatting = (doc, text, x, y) => {
    const pattern = /(\*\*.*?\*\*)/g;
    const parts = text.split(pattern);
    let cursorX = x;

    parts.forEach((part) => {
      if (!part) return;
      if (part.startsWith("**") && part.endsWith("**")) {
        const boldText = part.slice(2, -2);
        doc.setFont("helvetica", "bold");
        doc.text(boldText, cursorX, y);
        cursorX += doc.getTextWidth(boldText) + 1;
      } else {
        doc.setFont("helvetica", "normal");
        doc.text(part, cursorX, y);
        cursorX += doc.getTextWidth(part) + 1;
      }
    });
  };

  return generatePdf();
};
